import { batch, connect } from 'react-redux';
import type { Dispatch } from '@reduxjs/toolkit';

import { DeliveryBlock } from 'src/components/organisms/DeliverySection/components/DeliveryBlock/DeliveryBlock';
import type {
  DeliveryBlockDispatchProps,
  DeliveryBlockOnCountryChangeArgs,
  DeliveryBlockStateProps,
} from 'src/components/organisms/DeliverySection/components/DeliveryBlock/types';
import {
  selectGroupedCountriesForDropdown,
  selectProductDeliveryOptionsForZone,
} from 'src/components/organisms/DeliverySection/modules/selectors';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import {
  selectDecoratedDeliveryOptions,
  selectSelectedCountry,
  selectSelectedZone,
} from 'src/redux/delivery/selectors';
import { actions as deliveryActions } from 'src/redux/delivery/slice';
import { selectProduct } from 'src/redux/selectors';

const mapStateToProps = (state: ReduxApplicationState): DeliveryBlockStateProps => {
  const product = selectProduct(state);
  const deliveryOptionsPlaceholderItems = selectProductDeliveryOptionsForZone(state);
  const { delivery } = state;

  return {
    groupedCountries: selectGroupedCountriesForDropdown(state),
    deliveryOptions: selectDecoratedDeliveryOptions(state),
    deliveryOptionsPlaceholderItems,
    selectedCountry: `${selectSelectedCountry(state)}|${selectSelectedZone(state)}`,
    loading: delivery.deliveryZoneOptionsLoading,
    partnerName: product.partner.name,
    photoUploadRequired: product.specialFeatures.requiresPhotoUpload || false,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): DeliveryBlockDispatchProps => ({
  onCountryChange: (payload: DeliveryBlockOnCountryChangeArgs) => {
    batch(() => {
      dispatch(deliveryActions.setSelectedZone(payload.selectedZone));
      dispatch(deliveryActions.setSelectedCountry(payload));
    });
  },
});

export const DeliveryBlockContainer = connect(mapStateToProps, mapDispatchToProps)(DeliveryBlock);
